import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';



@Injectable({
  providedIn: 'root'
})
export class GuardSuccessOrderService {

  constructor(
    private authService: AuthService,
    private router: Router,


  ) { }


  canActivate(
    next: ActivatedRouteSnapshot|any,
    state: RouterStateSnapshot): any {

    let that = this;

   
    return new Promise(function (resolve) {
    // TODO : ??? mais c'est quoi ca ? code mort ?
      resolve(true);
      return;
      // console.log('next.queryParams.disable_authentification:', next.queryParams.disable_authentification)
      if (next.queryParams.disable_authentification) {
           resolve(true);
      }
      else {
        that.authService.checkIfAuth().then(function () {
          // console.log('authService:', next.queryParams.disable_authentification)
          resolve(true);
        }).catch(function (error) {
          that.router.navigate(["/404", "Non autorisé"], { skipLocationChange: true });
        })
      }

    })

  }
}
